var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchInputIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0805 12.8897L19.8955 18.6996C20.0584 18.8623 20.0584 19.1261 19.8955 19.2888L19.3059 19.878C19.143 20.0407 18.879 20.0407 18.7161 19.878L12.9011 14.0681C11.5395 15.17 9.8084 15.8334 7.92369 15.8334C3.55459 15.8334 0 12.2819 0 7.9167C0 3.55145 3.55455 0 7.92365 0C12.2927 0 15.8473 3.55145 15.8473 7.9167C15.8473 9.79975 15.1834 11.5293 14.0805 12.8897ZM1.66814 7.91667C1.66814 11.3631 4.47417 14.1667 7.92366 14.1667C11.3731 14.1667 14.1792 11.3631 14.1792 7.91667C14.1792 4.47022 11.3731 1.66667 7.92366 1.66667C4.47417 1.66667 1.66814 4.47022 1.66814 7.91667Z",
    className: "icon"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInputIcon);
export default __webpack_public_path__ + "static/media/search-input-icon.b7409108.svg";
export { ForwardRef as ReactComponent };